import { Dialog, Text } from "react-native-paper";
import DialogWrapper from "./DialogWrapper";

type Props = {
	isVisible: boolean;
	onClose?: () => void;
};

const title = "Migration is in progress";
const description =
	"Please wait while we migrate your data to the new platform. This may take a few minutes.";

const MigrationDialog = ({ isVisible, onClose }: Props) => {
	return (
		<DialogWrapper
			visible={isVisible}
			handleClose={onClose}
			showCloseButton={false}
			maxWidth={"xs"}
		>
			<Dialog.Icon icon="alert-outline" />
			<Dialog.Title style={{ textAlign: "center" }}>{title}</Dialog.Title>
			<Dialog.Content>
				<Text style={{ textAlign: "center" }}>{description}</Text>
			</Dialog.Content>
		</DialogWrapper>
	);
};

export default MigrationDialog;
